import React from "react";

import * as S from "./ProgressiveBlurGradient.styles";
import { IProgressiveBlurGradientProps } from "./ProgressiveBlurGradient.types";

export const ProgressiveBlurGradient = ({
  maxWidth,
  variant,
  isRounded,
  customGradientColor,
}: Readonly<IProgressiveBlurGradientProps>) => {
  return (
    <S.Container $maxWidth={maxWidth} $isRounded={isRounded}>
      <S.RelativeContainer>
        <S.BlurFilter />
        <S.BlurFilter />
        <S.BlurFilter />
        <S.BlurFilter />
        <S.BlurFilter />
        <S.BlurFilter />
        <S.Gradient
          $variant={variant}
          $customGradientColor={customGradientColor}
        />
      </S.RelativeContainer>
    </S.Container>
  );
};
